module.exports = __webpack_public_path__ + "static/img/img8.6884f0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img8.png
// module id = IApz
// module chunks = 1